import React from 'react'
import { WithTooltip } from '../../../design-system'
import { css, cx } from '@emotion/css'
import { updateRoute } from '../../route'
import { sendDefaultEvent } from '../../analytics'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { Link } from '@contrast-security-inc/design-system-typography'

const routeToEditForm = (organizationID: string, id: string) =>
  updateRoute(`/${organizationID}/rules/sensitive/edit/${id}`)

export function GroupIDCell({
  organizationID,
  isEditable,
  rowData: { id, groupID, name }
}: {
  readonly organizationID: string
  readonly isEditable: boolean
  readonly rowData: {
    readonly id: string
    readonly groupID: string
    readonly name: string
  }
}) {
  return (
    <WithTooltip
      tiny
      renderTooltipContent={() => <div>{groupID}</div>}
      placement="top"
      children={({ ref, onMouseEnter, onMouseLeave }) =>
        isEditable ? (
          <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <Link
              ref={ref}
              className={cx(
                css`
                  color: ${theme.color.neutral100};
                  &:hover {
                    text-decoration: underline;
                    color: ${theme.color.neutral100};
                  }
                  &:link,
                  &:visited,
                  &:hover,
                  &:focus {
                    color: ${theme.color.neutral100};
                  }
                `
              )}
              onClick={() => {
                routeToEditForm(organizationID, id)
                sendDefaultEvent('sensitive.data.edit.form.open')
              }}
            >
              {name}
            </Link>
          </div>
        ) : (
          <div>{name}</div>
        )
      }
    />
  )
}
